import React, { useState, useEffect } from "react";
import liff from "@line/liff";

export interface RegisterForm {
  name: string;
  mobile: string;
  user_id: string;
  display_name?: string;
  avatar?: string;
}

export interface inputProps {
  inputName: string;
  inputValue: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  required?: boolean;
}

export const Input = ({
  inputName,
  inputValue,
  onChange,
  disabled,
  required,
}: inputProps) => {
  return (
    <input
      type="text"
      name={inputName}
      value={inputValue}
      onChange={onChange}
      disabled={disabled}
      required={required}
      className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-full sm:text-sm focus:ring-1 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
    />
  );
};

export const Label = ({
  labelName,
  children,
}: {
  labelName: string;
  children: React.ReactNode;
}) => {
  return (
    <label className="block">
      <span className="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
        {labelName}
      </span>
      {children}
    </label>
  );
};

const RegisterPage = () => {
  // const [idToken, setIdToken] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [userId, setUserId] = useState("");
  const [avatar, setAvatar] = useState("");
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [profile, setProfile] = useState<any | undefined>(null);

  const initializeLiff = async () => {
    await liff.init({ liffId: process.env.REACT_APP_LIFF_ID! });
    if (liff.isLoggedIn()) {
      setProfile(await liff.getProfile());
      // setIdToken(liff.getIDToken());
      setDisplayName(profile.displayName);
      setUserId(profile.userId);
      setAvatar(profile.pictureUrl);
    } else {
      liff.login();
    }
  };

  const handleRegister = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const data: RegisterForm = {
      name,
      mobile,
      user_id: userId,
      display_name: displayName,
      avatar,
    };
    const response = await fetch("/api/register", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    console.log(result);
  };

  useEffect(() => {
    initializeLiff();
    document.title = "Register";
  }, []);

  return (
    <div className="container mx-auto mt-[64px]">
      <div className="mb-16 py-1">
        <div className="container mx-auto max-w-md bg-white px-4">
          <form onSubmit={handleRegister}>
            <div className="mt-6">
              <Label labelName="Name:">
                <Input
                  inputName="name"
                  inputValue={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </Label>
            </div>

            <div className="mt-6">
              <Label labelName="Mobile:">
                <Input
                  inputName="mobile"
                  inputValue={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                  required
                />
              </Label>
            </div>

            <div className="mt-6">
              <Label labelName="User ID:">
                <Input
                  inputName="user_id"
                  inputValue={userId}
                  onChange={(e) => setUserId(e.target.value)}
                  disabled
                />
              </Label>
            </div>

            <div className="mt-6">
              <Label labelName="Display Name:">
                <Input
                  inputName="display_name"
                  inputValue={displayName}
                  onChange={(e) => setDisplayName(e.target.value)}
                  disabled
                />
              </Label>
            </div>

            <div className="mt-6">
              <Label labelName="Avatar:">
                <Input
                  inputName="avatar"
                  inputValue={avatar}
                  onChange={(e) => setAvatar(e.target.value)}
                  disabled
                />
              </Label>
            </div>

            <div className="grid place-items-center mt-6 px-3 py-2">
              <button
                type="submit"
                className="bg-violet-500 hover:bg-violet-600 focus:outline-none focus:ring focus:ring-violet-300 active:bg-violet-700 px-5 py-2 text-sm leading-5 rounded-full font-semibold text-white"
              >
                Register
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
